export default __webpack_public_path__ + "static/media/Skyhawk's Edge.ff5b4e27.jpg";